import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Col,
  Row,
  Form
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";

function MijloaceFixeList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  const fetchItems = useCallback(async () => {
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/mijloace_fixe/", {
        params: {
          search,
          offset: skip,
          limit: itemsPerPage,
        },
      });
      // The backend returns a paginated response {"total": int, "items": []}
      if (res.data && res.data.items) {
         setItems(res.data.items);
         setTotalCount(res.data.total);
      }
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")) {
      try {
        await api.delete(`/mijloace_fixe/${id}`);
        fetchItems();
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  const [selectedMonth, setSelectedMonth] = useState("");

  const handleScriereNote = async () => {
    if (!selectedMonth) {
      alert("Te rog selectează luna (ex: 2024-03)");
      return;
    }
    const year = parseInt(selectedMonth.split("-")[0]);
    const month = parseInt(selectedMonth.split("-")[1]) - 1;
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const fDayStr = `${year}-${String(month+1).padStart(2,'0')}-01`;
    const lDayStr = `${year}-${String(month+1).padStart(2,'0')}-${String(lastDay.getDate()).padStart(2,'0')}`;

    try {
      const res = await api.post("/mijloace_fixe/scriere_amortizare/", {
        firstDay: fDayStr,
        lastDay: lDayStr
      });
      if (res.data.result === 'pass') {
        if (res.data.inserate > 0) {
          alert(`Amortizare scrisă cu succes! S-au inserat ${res.data.inserate} linii.`);
        } else {
          alert("Nu s-a inserat nicio linie. Verificați că există amortizare pe luna anterioară.");
        }
        fetchItems();
      } else {
        alert("Eroare la scriere amortizare.");
      }
    } catch (err) {
      alert("Eroare API la scriere amortizare.");
    }
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col md={4}>
          <h2>Lista Mijloace Fixe</h2>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Form.Group className="me-2">
            <Form.Label className="mb-0">Luna (YYYY-MM)</Form.Label>
            <Form.Control type="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} />
          </Form.Group>
          <Button variant="warning" onClick={handleScriereNote}>
            Scriere note contabile
          </Button>
        </Col>
        <Col md={4} className="text-end">
          <Button onClick={() => navigate("/mijloace-fixe/new")}>
            Adaugă Mijloc Fix
          </Button>
        </Col>
      </Row>
      <Row className="mb-3 align-items-end">
        <Col md={8}>
          <Form.Label htmlFor="mf-search">Caută după denumire sau număr de inventar</Form.Label>
          <FormControl id="mf-search" value={search} onChange={handleSearchChange} />
        </Col>
        <Col md={4}>
          <Form.Label htmlFor="mf-page-size">Rânduri pe pagină</Form.Label>
          <Form.Select id="mf-page-size" value={itemsPerPage} onChange={(e) => {
            setItemsPerPage(Number(e.target.value));
            setCurrentPage(0);
          }}>
            {[10, 25, 50, 100].map(size => <option key={size} value={size}>{size}</option>)}
          </Form.Select>
        </Col>
      </Row>
      <p role="status">
        Afișate {items.length ? currentPage * itemsPerPage + 1 : 0}–{items.length ? currentPage * itemsPerPage + items.length : 0} din {totalCount} mijloace fixe
      </p>
      
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Număr Inv.</th>
            <th>Denumire</th>
            <th>Stare</th>
            <th>Data PIF</th>
            <th>Valoare</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.bxid}>
              <td>{it.bxid}</td>
              <td>{it.bxnumar_inv}</td>
              <td>{it.bxdenumire}</td>
              <td>{it.bxstare}</td>
              <td>{it.bxdata1}</td>
              <td>{it.bxvalinv}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => navigate(`/mijloace-fixe/${it.bxid}`)}
                >
                  Editează
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(it.bxid)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {pageCount > 1 && (
        <nav aria-label="Paginare mijloace fixe">
          <ReactPaginate
            previousLabel="Înapoi"
            nextLabel="Înainte"
            breakLabel="…"
            pageCount={pageCount}
            forcePage={currentPage}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            containerClassName="pagination justify-content-center"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            activeClassName="active"
            disabledClassName="disabled"
          />
        </nav>
      )}
    </Container>
  );
}

export default MijloaceFixeList;
